export enum AffiliateAccessStatus {
  Closed,
  Opened,
  Rejected,
  New,
}
